import SimpleType from "sap/ui/model/SimpleType";

/**
 * @extends sap.ui.model.SimpleType
 * @namespace com.unitrade.crm.types
 */
export default class CurrencyColorType extends SimpleType {
  formatValue(vValue: number) {
    if (vValue) {
      if (vValue > 1500) {
        return 7;
      } else if (vValue > 500) {
        return 6;
      } else if (vValue > 1) {
        return 1;
      }
    }

    return 3;
  }
}
